import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const TableHead: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="multi-account__admin__table-row">
      <div className="multi-account__admin__table-cell multi-account__admin__table-th multi-account__admin__table-id">
        {t('multiAccount.account')}
      </div>
      <div className="multi-account__admin__table-cell multi-account__admin__table-th multi-account__admin__table-info">
        {t('multiAccount.address')}
      </div>
      <div className="multi-account__admin__table-cell multi-account__admin__table-th multi-account__admin__table-info">
        {t('multiAccount.name')}
      </div>
      <div className="multi-account__admin__table-cell multi-account__admin__table-th multi-account__admin__table-info">
        {t('multiAccount.status')}
      </div>
      <div className="multi-account__admin__table-cell multi-account__admin__table-th multi-account__admin__table-options">
        {t('multiAccount.actions')}
      </div>
    </div>
  );
};
